var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgScooter = function SvgScooter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M6.4.5a.5.5 0 0 1 .5-.5h.8a2.1 2.1 0 0 1 2.099 2.1v4a2.9 2.9 0 0 1-2.9 2.9H1.3A1.3 1.3 0 0 1 .043 7.373 3.43 3.43 0 0 1 3.409 4.8h-.003v.5l.006-.5H3.41h1.478-.013l.025.5v-.5h-.012a3.18 3.18 0 0 1 2.669 1.238.5.5 0 0 1-.793.61A2.18 2.18 0 0 0 4.9 5.8H3.4a2.43 2.43 0 0 0-2.39 1.824A.3.3 0 0 0 1.3 8h5.6a1.9 1.9 0 0 0 1.9-1.9v-4A1.1 1.1 0 0 0 7.7 1h-.8a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M10.97 5.6A2.1 2.1 0 0 1 12.95 7a.5.5 0 0 1 .025.113c.047.44.027.883-.06 1.316a.5.5 0 0 1-.082.19.9.9 0 0 1-.735.38h-5.2a.5.5 0 0 1 0-1h5.075q.045-.357.014-.718a1.1 1.1 0 0 0-1.018-.681H9.3a.5.5 0 0 1 0-1zm-.627-3.59a.1.1 0 0 0-.104.01 1.1 1.1 0 0 0 0 1.76.1.1 0 0 0 .16-.08V2.1a.1.1 0 0 0-.056-.09m-.705-.79a1.1 1.1 0 0 1 1.76.88v1.6a1.1 1.1 0 0 1-1.76.88 2.1 2.1 0 0 1 0-3.36M1.599 3.7a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m-.8 4.8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.4a2.5 2.5 0 0 1-5 0zm1.003.5a1.5 1.5 0 0 0 2.993 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M7.199 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.4a2.5 2.5 0 0 1-5 0zm1.003.5a1.5 1.5 0 0 0 2.993 0z",
    clipRule: "evenodd"
  })));
};
export default SvgScooter;